const fieldsMapping = {
    paperTitle: 'Paper Title',
    organizer : 'Name of the Organizer',
    place: "Place",
    isbn : 'ISBN',
    sPageNo :  'Starting Page Number',
    ePageNo : 'Ending Page Number',
    epageno: 'Ending Page Number',
    spageno :  'Starting Page Number',
    startDate  : 'Start Date',
    endDate : 'End Date',
    pubDate : 'Publishing Date',
    publisher : 'Name of the publisher',
    finType : 'Finance Type (Self / College Sponsored)',
    regionType : 'Region Type (National / International)',
    authors : 'Authors’ Name (Separated by comma)',
    remarks: 'Remarks (if any)',
    title : 'Title',
    pubCategory: 'Publication Category',
    jname: "Journal Name",
    volumeno: "Volume Number",
    issueno: "Issue Number",
    issn : "ISSN",
    webUrl: "Website’s URL (If online)",
    indexedBy: "Indexed By (Scopus/WOS/SCI/ESCI)",
    isUgcApproved: "Whether UGC Approved (Yes/No)",
    isHardCopy: "Is Hard Copy Submitted in the Library? (Yes/No)",
    activityName: "Activity Name",
    awardName: "Award Name",
    awardingInstitution: "Awarding Institution",
    awardDate: "Award Date",
    isPublished: "Whether Published? (Yes / No)",
}

export default fieldsMapping;
